// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2Zfob","title":"AfterBackImages_title__2TPdf","images":"AfterBackImages_images__3w8ah"};